import template from '../templates/header_content.jst';

import View from "backdraft-app/src/view";

export default class KeywordsHeaderContent extends View {
  render() {
    this.$el.html(template());
    return this;
  }
}
